import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import classNames from 'classnames';

import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import NavBar from 'components/NavBar';
import styles from './SuperBatchManagementSidebar.module.scss';
import SUPER_BATCH_MANAGEMENT_SIDEBAR_DATA from 'data/superBatchManagementSidebarData';
import WithPermissions from 'components/WithPermissions';

export default function SuperBatchManagementSidebar() {
  return (
    <>
      <NavBar
        title="SUPER BATCH MANAGEMENT TOOL"
        className="p-xs"
        id="super-batch-management-sidebar"
      />
      <ElementSpacePlaceholder elementId="super-batch-management-sidebar" />
      <div className={styles.root}>
        {SUPER_BATCH_MANAGEMENT_SIDEBAR_DATA.map((data, sectionIndex) => (
          <div
            className={styles.section}
            key={`super-batch-manage-sidebar-${sectionIndex}`}
          >
            <div
              className={classNames('bold', 'dark', styles.header)}
              key={sectionIndex}
            >
              {data.header}
            </div>
            <div className={styles.tabs}>
              {data.tabs.map((tab, tabIndex) => (
                <WithPermissions
                  key={`super-batch-management-tabs-${tabIndex}`}
                  subject={tab.subject}
                  permissions={tab.permissions}
                >
                  <NavLink
                    to={tab.to}
                    tabIndex={tabIndex}
                    className={({ isActive }) =>
                      classNames(styles.tab, { [styles.tabActive]: isActive })
                    }
                  >
                    {tab.tabName}
                  </NavLink>
                </WithPermissions>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.page}>
        <Outlet />
      </div>
    </>
  );
}
